// extracted by mini-css-extract-plugin
export default {"container":"ev-z","heading":"fv-z","text":"gv-z","info":"hv-z","link":"iv-z","fullMaxWidth":"jv-z"};